<!-- Loader pendant la vérification de l'authentification -->
<div 
    *ngIf="isUserLoading()" 
    class="flex justify-content-center align-items-center"
    style="min-height: 80vh; width: 100%;">
    <div 
        class="text-center mx-auto mt-20" 
        aria-label="loading-content">
        <p-progressSpinner 
            strokeWidth="4" 
            fill="transparent" 
            animationDuration=".5s"
            [style]="{ width: '60px', height: '60px' }">
        </p-progressSpinner>
        <p class="mt-4 text-muted-color text-lg">Vérification de votre connexion...</p>
    </div>
</div>

<!-- Message d'erreur si la vérification utilisateur échoue -->
<div 
    *ngIf="!isUserLoading() && !isUserAuthenticated()" 
    aria-labelledby="error-content"
    class="flex justify-content-center align-items-center"
    style="min-height: 80vh; width: 100%;">
    <div 
        class="text-center mx-auto mt-20" 
        aria-label="error-content">
        <i class="pi pi-exclamation-triangle text-red-500 text-6xl mb-4"></i>
        <h2 class="text-2xl font-bold text-red-700 mb-4">Erreur de connexion</h2>
        <p class="text-lg text-muted-color mb-6">
            Une erreur est survenue lors de la vérification de votre authentification.
        </p>
        <button pButton type="button" 
            class="p-button-outlined p-button-secondary" 
            icon="pi pi-refresh" 
            label="Réessayer"
            (click)="retryAuthentication()">
        </button>
    </div>
</div>

<!-- Contenu principal affiché seulement si l'utilisateur est authentifié -->
<div aria-labelledby="main-content" data-testid="dashboard-main" *ngIf="shouldShowContent()" class="grid grid-cols-12 gap-4">
    <div aria-label="mobile-device-install-banner" *ngIf="showInstallBanner() && !isInStandaloneMode()" class="col-span-12">
        <div class="bg-white dark:bg-surface-900 shadow flex flex-col gap-3 p-3 sm:p-4 relative"
            style="border-radius: 14px">
            <button pButton type="button"
                class="p-button-text p-button-plain p-button-sm absolute right-2 top-2 sm:right-3 sm:top-3"
                icon="pi pi-times" (click)="closeInstallBanner()" aria-label="Fermer le bandeau"></button>

            <div class="flex items-start sm:items-center gap-3 flex-1 min-w-0 pr-8">
                <img src="assets/plateformebeneficiaire/images/logo.png" alt="Logo application"
                    class="h-8 w-8 sm:h-10 sm:w-10 shrink-0" />
                <div class="min-w-0">
                    <div class="text-base sm:text-lg font-medium">Installez l’application mobile</div>
                    <div class="text-muted-color text-xs sm:text-sm leading-snug whitespace-normal break-words">
                        Retrouvez l’application plus rapidement depuis votre téléphone.
                    </div>
                </div>
            </div>

            <div class="w-full mt-1 sm:mt-2">
                <div class="flex justify-center">
                    <button pButton type="button" (click)="installMobileApp()"
                        class="p-button-primary p-button-sm w-full sm:w-auto" icon="pi pi-download"
                        label="Installer l’application"></button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-span-12">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
            <div class="flex items-center">
                <div class="ml-4" aria-label="page-title">
                    <span data-testid="dashboard-greeting" class="text-4xl font-light">{{ 'homepage.hello' | translate }} <span
                            class="font-normal" aria-label="prenom-title">{{ prenomUser() }}</span></span>
                    <div class="text-muted-color">{{ 'homepage.date' | translate }}</div>
                </div>
            </div>
            <div class="flex"></div>
            <div class="flex items-center max-xl:hidden">
                <div class="ml-4">
                    <span class="text-3xl font-light">{{ 'homepage.welcome' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-span-12 p-4 sm:p-12 sm:pt-6 md:p-18">
        <!-- Conteneur principal -->
        <div class="xl:flex flex-col sm:flex-row justify-center grid grid-cols-12 gap-8">

            <!-- Envoi de fichiers (sm: card 1/4, xl: col 1/3)) -->
            <div 
                aria-label="send-files-container"
                class="bg-white dark:bg-surface-900 col-span-6 text-center py-2 px-2 sm:py-8 sm:px-8 shadow"
                style="border-radius: 14px">
                <!-- <div class="text-xl text-muted-color mb-4">Fichiers</div> -->
                <h3 class="mt-0 mb-4 font-bold text-4xl md:block hidden">
                    {{ 'homepage.send_files_title' | translate }}
                </h3>
                <p class="leading-normal mb-8 text-muted-color md:block hidden">
                    {{ 'homepage.send_files_desc' | translate }}
                </p>
                <button [disabled]="!linkApplicationEnabled()" pButton icon="pi pi-arrow-right"
                    [label]="'homepage.send_files_btn' | translate"
                    class="p-button-text p-button-primary md:flex hidden mx-auto" iconPos="right" (click)="goToFiles()"
                    [class]="{'cursor-not-allowed': !linkApplicationEnabled()}"></button>
                <br />
                <i *ngIf="!linkApplicationEnabled()" class="text-red-700 md:flex hidden">
                    {{ 'homepage.feature_disabled' | translate }}
                </i>
                <div class="mt-5 lg:mt-20 xl:pt-10">
                    <img alt="intro image" src="assets/plateformebeneficiaire/images/envoi-doc.svg"
                        class="w-9/12 md:w-4/12 lg:w-9/12 xl:w-9/12 mx-auto">
                </div>
                <button [disabled]="!linkApplicationEnabled()" pButton icon="pi pi-arrow-right"
                    [label]="'homepage.send_files_btn' | translate"
                    class="p-button-text p-button-primary md:hidden mt-2" iconPos="right" (click)="goToFiles()"
                    [class]="{'cursor-not-allowed': !linkApplicationEnabled()}"></button>
                <br />
                <i *ngIf="!linkApplicationEnabled()" class="text-red-700 md:hidden">
                    {{ 'homepage.feature_disabled' | translate }}
                </i>
            </div>

            <!-- Partie très grands écrans (sm: hidden , xl: col 2/3) -->
            <div class="hidden xl:flex flex-col col-span-12 gap-8 ">

                <!-- Rendez-vous (partie haute) -->
                <div class="flex-1 bg-white dark:bg-surface-900 flex flex-col xl:flex-row xl:items-center justify-between py-2 px-2 sm:py-8 sm:px-8 shadow gap-8"
                    style="border-radius: 14px">
                    <div class="flex-1 order-1 xl:order-none text-center xl:text-left">
                        <img alt="intro image" src="assets/plateformebeneficiaire/images/rdv.svg"
                            class="w-9/12 mx-auto">
                    </div>
                    <div aria-labelledby="smallscreens-meeting-container"
                        class="text-center xl:text-right flex-1 md:block hidden">
                        <!-- <div class="text-xl text-muted-color mb-4">Rendez-vous</div> -->
                        <h3 class="mt-0 mb-4 font-bold text-4xl">
                            <span class="hidden sm:inline">{{ 'homepage.appointment_title' | translate }}</span>
                            <span class="inline sm:hidden">{{ 'homepage.appointment_title_short' | translate }}</span>
                        </h3>
                        <p class="leading-normal mb-8 text-muted-color"
                            [innerHTML]="'homepage.appointment_desc' | translate"></p>
                        <button [disabled]="!meetingsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.appointment_btn' | translate" class="p-button-text p-button-primary"
                            iconPos="right" (click)="goToMeetings()"
                            [class]="{'cursor-not-allowed': !meetingsEnabled()}"></button>
                        <br />
                        <i *ngIf="!meetingsEnabled()" class="text-red-700">
                            {{ 'homepage.feature_disabled' | translate}}
                        </i>
                    </div>
                </div>

                <!-- Actualités (partie basse) -->
                <div class="flex-1 bg-white dark:bg-surface-900 flex flex-col xl:flex-row xl:items-center justify-between py-2 px-2 sm:py-8 sm:px-8 shadow gap-8"
                    style="border-radius: 14px">
                    <div class="text-center xl:text-left flex-1">
                        <!-- <div class="text-xl text-muted-color mb-4">Actualités</div> -->
                        <h3 class="mt-0 mb-4 font-bold text-4xl">{{ 'homepage.news_title' | translate }}</h3>
                        <p class="leading-normal mb-8 text-muted-color">{{ 'homepage.news_desc' | translate }}</p>
                        <button 
                            [disabled]="!newsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.news_btn' | translate" class="p-button-text p-button-primary"
                            iconPos="right" (click)="scrollTo(listearticles)"
                            [class]="{'cursor-not-allowed': !newsEnabled()}"></button>
                        <br />
                        <i *ngIf="!newsEnabled()" class="text-red-700">{{ 'homepage.feature_disabled' | translate }}</i>
                    </div>
                    <div class="flex-1 text-center xl:text-right">
                        <img 
                            alt="intro image" 
                            src="assets/plateformebeneficiaire/images/actu.svg"
                            class="w-9/12 mx-auto">
                    </div>
                </div>
            </div>

            <!-- Partie petits écrans (sm: card 2/4, xl: hidden) ( en dessous de XL) -->
            <div class="xl:hidden flex col-span-6 gap-8">
                <div class="flex-1 bg-white dark:bg-surface-900 flex flex-col xl:flex-row xl:items-center justify-between py-2 px-2 sm:py-8 sm:px-8 shadow gap-8"
                    style="border-radius: 14px">
                    <div aria-labelledby="smallscreens-meeting-container"
                        class="flex-1 order-1 xl:order-none text-center xl:text-left lg:mt-0 mt-5">
                        <img alt="intro image" src="assets/plateformebeneficiaire/images/dossier-1.svg"
                            class="w-9/12 mx-auto">
                        <!-- Résolution petite -->
                        <button [disabled]="!meetingsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.appointment_title_short' | translate"
                            class="p-button-text p-button-primary md:hidden mt-2" iconPos="right"
                            (click)="goToMeetings()" [class]="{'cursor-not-allowed': !meetingsEnabled()}"></button>
                        <br />
                        <i *ngIf="!meetingsEnabled()" class="text-red-700 md:hidden">
                            {{ 'homepage.feature_disabled' | translate }}
                        </i>
                    </div>
                    <!-- Résolution moyenne -->
                    <div class="text-center xl:text-right flex-1 md:block hidden">
                        <h3 class="mt-0 mb-4 font-bold text-4xl">
                            <span class="hidden sm:inline">{{ 'homepage.appointment_title' | translate }}</span>
                            <span class="inline sm:hidden">{{ 'homepage.appointment_title_short' | translate }}</span>
                        </h3>
                        <p class="leading-normal mb-8 text-muted-color"
                            [innerHTML]="'homepage.appointment_desc' | translate"></p>
                        <button [disabled]="!meetingsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.appointment_btn' | translate" class="p-button-text p-button-primary"
                            iconPos="right" (click)="goToMeetings()"
                            [class]="{'cursor-not-allowed': !meetingsEnabled()}"></button>
                        <br />
                        <i *ngIf="!meetingsEnabled()" class="text-red-700">
                            {{ 'homepage.feature_disabled' | translate }}
                        </i>
                    </div>
                </div>
            </div>

            <!-- Partie petits écrans (sm : card 3/4, xl: hidden) (en dessous de XL) -->
            <div class="xl:hidden flex col-span-6 gap-8">
                <div class="flex-1 bg-white dark:bg-surface-900 flex flex-col xl:flex-row xl:items-center justify-between py-2 px-2 sm:py-8 sm:px-8 shadow gap-8"
                    style="border-radius: 14px">

                    <!-- Résolution moyenne -->
                    <div class="text-center xl:text-left flex-1 md:block hidden">
                        <!-- <div class="text-xl text-muted-color mb-4">Actualités</div> -->
                        <h3 class="mt-0 mb-4 font-bold text-4xl">{{ 'homepage.news_title' | translate }}</h3>
                        <p class="leading-normal mb-8 text-muted-color">{{ 'homepage.news_desc' | translate }}</p>
                        <button [disabled]="!newsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.news_btn' | translate" class="p-button-text p-button-primary"
                            iconPos="right" (click)="scrollTo(listearticles)"
                            [class]="{'cursor-not-allowed': !newsEnabled()}"></button>
                        <br />
                        <i *ngIf="!newsEnabled()" class="text-red-700">{{ 'homepage.feature_disabled' | translate }}</i>
                    </div>
                    <div class="flex-1 text-center xl:text-right lg:mt-0 mt-5">
                        <img 
                            alt="intro image" 
                            src="assets/plateformebeneficiaire/images/actu.svg"
                            class="w-9/12 mx-auto">


                        <!-- Résolution petite -->
                        <button 
                            [disabled]="!newsEnabled()" pButton icon="pi pi-arrow-right"
                            [label]="'homepage.news_btn_short' | translate"
                            class="p-button-text p-button-primary md:hidden mt-2" iconPos="right"
                            (click)="scrollTo(listearticles)" [class]="{'cursor-not-allowed': !newsEnabled()}"></button>
                        <br />
                        <i *ngIf="!newsEnabled()" class="text-red-700 md:hidden">
                            {{ 'homepage.feature_disabled' | translate }}
                        </i>
                    </div>
                </div>
            </div>

            <!-- Liste de tâches (sm: card 4/4, xl: col 3/3) -->
            <div
                aria-label="todolist-container" 
                class="bg-white dark:bg-surface-900 text-center py-2 px-2 sm:py-8 sm:px-8 shadow col-span-6"
                style="border-radius: 14px">
                <!-- Résolution moyenne -->
                <div class="md:block hidden">
                    <h3 class="mt-0 mb-4 font-bold text-4xl">{{ 'homepage.todolist_title' | translate }}</h3>
                    <p class="leading-normal mb-8 text-muted-color">{{ 'homepage.todolist_desc' | translate }}</p>
                    <button [disabled]="!linkApplicationEnabled()" pButton icon="pi pi-arrow-right"
                        [label]="'homepage.todolist_btn' | translate" class="p-button-text p-button-primary"
                        iconPos="right" (click)="goToTodolist()"
                        [class]="{'cursor-not-allowed': !linkApplicationEnabled()}"></button>
                    <br />
                    <i *ngIf="!linkApplicationEnabled()" class="text-red-700">
                        {{ 'homepage.feature_disabled' | translate }}
                    </i>
                </div>

                <!-- Résolution petite -->
                <div class="mt-10 lg:mt-20 xl:pt-10">
                    <img alt="intro image" src="assets/plateformebeneficiaire/images/dossier-1.svg"
                        class="w-9/12 md:w-4/12 lg:w-9/12 xl:w-9/12 mx-auto">
                </div>
                <button [disabled]="!linkApplicationEnabled()" pButton icon="pi pi-arrow-right"
                    [label]="'homepage.todolist_btn_short' | translate"
                    class="p-button-text p-button-primary md:hidden mt-2" iconPos="right" (click)="goToTodolist()"
                    [class]="{'cursor-not-allowed': !linkApplicationEnabled()}"></button>
                <br />
                <i *ngIf="!linkApplicationEnabled()" class="text-red-700 md:hidden">
                    {{ 'homepage.feature_disabled' | translate }}
                </i>
            </div>
        </div>
    </div>

    <div #listearticles class="col-span-12 list-articles-container">
        <div *ngIf="newsEnabled()">
            <h4 class="ml-4">Quelques actualités</h4>
            <app-news />
        </div>
    </div>
</div>